export const iconlyIconData = [
    { title: 'Activity', data: 'iconly-Activity icli' },
    { title: 'Add-User', data: 'iconly-Add-User icli' },
    { title: 'Arrow-Down', data: 'iconly-Arrow-Down icli' },
    { title: 'Arrow-Down-2', data: 'iconly-Arrow-Down-2 icli' },
    { title: 'Arrow-Down-3', data: 'iconly-Arrow-Down-3 icli' },
    { title: 'Arrow-Down-Circle', data: 'iconly-Arrow-Down-Circle icli' },
    { title: 'Arrow-Down-Square', data: 'iconly-Arrow-Down-Square icli' },
    { title: 'Arrow-Left', data: 'iconly-Arrow-Left icli' },
    { title: 'Arrow-Left-2', data: 'iconly-Arrow-Left-2 icli' },
    { title: 'Arrow-Left-3', data: 'iconly-Arrow-Left-3 icli' },
    { title: 'Arrow-Left-Circle', data: 'iconly-Arrow-Left-Circle icli' },
    { title: 'Arrow-Left-Square', data: 'iconly-Arrow-Left-Square icli' },
    { title: 'Arrow-Right', data: 'iconly-Arrow-Right icli' },
    { title: 'Arrow-Right-2', data: 'iconly-Arrow-Right-2 icli' },
    { title: 'Arrow-Right-3', data: 'iconly-Arrow-Right-3 icli' },
    { title: 'Arrow-Right-Circle', data: 'iconly-Arrow-Right-Circle icli' },
    { title: 'Arrow-Up', data: 'iconly-Arrow-Up icli' },
    { title: 'Arrow-Up-2', data: 'iconly-Arrow-Up-2 icli' },
    { title: 'Arrow-Up-3', data: 'iconly-Arrow-Up-3 icli' },
    { title: 'Arrow-Up-Circle', data: 'iconly-Arrow-Up-Circle icli' },
    { title: 'Bag', data: 'iconly-Bag icli' },
    { title: 'Bag-2', data: 'iconly-Bag-2 icli' },
    { title: 'Bookmark', data: 'iconly-Bookmark icli' },
    { title: 'Buy', data: 'iconly-Buy icli' },
    { title: 'Calendar', data: 'iconly-Calendar icli' },
    { title: 'Call', data: 'iconly-Call icli' },
    { title: 'Call-Missed', data: 'iconly-Call-Missed icli' },
    { title: 'Call-Silent', data: 'iconly-Call-Silent icli' },
    { title: 'Calling', data: 'iconly-Calling icli' },
    { title: 'Camera', data: 'iconly-Camera icli' },
    { title: 'Category', data: 'iconly-Category icli' },
    { data: "iconly-Chart icli", title: 'Chart' },
    { data: "iconly-Chat icli", title: 'Chat' },
    { data: "iconly-Close-Square icli", title: 'Close - Square' },
    { data: "iconly-Danger icli", title: 'Danger' },
    { data: "iconly-Delete icli", title: 'Delete' },
    { data: "iconly-Discount icli", title: 'Discount' },
    { data: "iconly-Discovery icli", title: 'Discovery' },
    { data: "iconly-Document icli", title: 'Document' },
    { data: "iconly-Download icli", title: 'Download' },
    { data: "iconly-Edit icli", title: 'Edit' },
    { data: "iconly-Edit-Square icli", title: 'Edit - Square' },
    { data: "iconly-Filter icli", title: 'Filter' },
    { data: "iconly-Filter-2 icli", title: 'Filter - 2' },
    { data: "iconly-Folder icli", title: 'Folder' },
    { data: "iconly-Game icli", title: 'Game' },
    { data: "iconly-Graph icli", title: 'Graph' },
    { data: "iconly-Heart icli", title: 'Heart' },
    { data: "iconly-Hide icli", title: 'Hide' },
    { data: "iconly-Home icli", title: 'Home' },
    { data: "iconly-Image icli", title: 'Image' },
    { data: "iconly-Image-2 icli", title: 'Image - 2' },
    { data: "iconly-Info-Circle icli", title: 'Info - Circle' },
    { data: "iconly-Info-Square icli", title: 'Info - Square' },
    { data: "iconly-Location icli", title: 'Location' },
    { data: "iconly-Lock icli", title: 'Lock' },
    { data: "iconly-Login icli", title: 'Login' },
    { data: "iconly-Logout icli", title: 'Logout' },
    { data: "iconly-Message icli", title: 'Message' },
    { data: "iconly-More-Circle icli", title: 'More - Circle' },
    { data: "iconly-More-Square icli", title: 'More - Square' },
    { data: "iconly-Notification icli", title: 'Notification' },
    { data: "iconly-Paper icli", title: 'Paper' },
    { data: "iconly-Paper-Download icli", title: 'Paper - Download' },
    { data: "iconly-Paper-Fail icli", title: 'Paper - Fail' },
    { data: "iconly-Paper-Negative icli", title: 'Paper - Negative' },
    { data: "iconly-Paper-Plus icli", title: 'Paper - Plus' },
    { data: "iconly-Paper-Upload icli", title: 'Paper - Upload' },
    { data: "iconly-Password icli", title: 'Password' },
    { data: "iconly-Play icli", title: 'Play' },
    { data: "iconly-Plus icli", title: 'Plus' },
    { data: "iconly-Profile icli", title: 'Profile' },
    { data: "iconly-Scan icli", title: 'Scan' },
    { data: "iconly-Search icli", title: 'Search' },
    { data: "iconly-Send icli", title: 'Send' },
    { data: "iconly-Setting icli", title: 'Setting' },
    { data: "iconly-Shield-Done icli", title: 'Shield - Done' },
    { data: "iconly-Shield-Fail icli", title: 'Shield - Fail' },
    { data: "iconly-Show icli", title: 'Show' },
    { data: "iconly-Star icli", title: 'Star' },
    { data: "iconly-Swap icli", title: 'Swap' },
    { data: "iconly-Tick-Square icli", title: 'Tick - Square' },
    { data: "iconly-Ticket icli", title: 'Ticket' },
    { data: "iconly-Ticket-Star icli", title: 'Ticket - Star' },
    { data: "iconly-Time-Circle icli", title: 'Time - Circle' },
    { data: "iconly-Time-Square icli", title: 'Time - Square' },
    { data: "iconly-Unlock icli", title: 'Unlock' },
    { data: "iconly-Upload icli", title: 'Upload' },
    { data: "iconly-User2 icli", title: 'User2' },
    { data: "iconly-User3 icli", title: 'User3' },
    { data: "iconly-Video icli", title: 'Video' },
    { data: "iconly-Voice icli", title: 'Voice' },
    { data: "iconly-Voice-2 icli", title: 'Voice - 2' },
    { data: "iconly-Volume-Down icli", title: 'Volume - Down' },
    { data: "iconly-Volume-Off icli", title: 'Volume - Off' },
]